<div class="porfolio-properties-wrapper">
  <div *ngIf="showTitleInfo">
    <h2>{{'raci.publishToValorem.title' | translate | uppercase}}</h2>
  </div>
  <div class="valorem-table-border-red" *ngIf="valoremPublishInformation && valoremPublishInformation?.publishStatus">
    <p class="valorem-table-header">Publish Status</p>
    <table class="valorem-properties-table" aria-hidden="true">
      <tr class="valorem-table-content">
        <td class="valorem-content-title">Last Published</td>
        <td class="valorem-content-title">{{valoremPublishInformation?.lastPublishedDate | date: 'dd/MM/YYYY HH:mm'}}</td>
        <td class="valorem-content-title">Valorem Client ID</td>
        <td class="valorem-content-title">{{valoremPublishInformation?.clientId}}</td>
      </tr>
      <tr class="valorem-table-content">
        <td class="valorem-content-title">Published by</td>
        <td class="valorem-content-title">{{valoremPublishInformation?.publishedByUserDescription}}</td>
        <td class="valorem-content-title">Valorem Project ID</td>
        <td class="valorem-content-title">{{valoremPublishInformation?.projectId}}</td>
      </tr>
    </table>
  </div>
  <div class="porfolio-properties-body">
    <div class="porfolio-properties-project">
      <svg-icon src='./assets/icons/icon-by-region-default.svg'
                title="{{'raci.participantsAssignment.participants' | translate | uppercase}}"
                class="menu-action-icon svg-icon-red"
                align='center'>
      </svg-icon>
      <div *ngIf="_allowApproving && activeTask?.taskActionStage === ActionStageEnum.Waiting ">
        <input type="checkbox"
               [(ngModel)]="isProjectSelected"
               (click)="selectAllProperties()" />
      </div>
    </div>
    <div class="portfolio-properties">
      <div class="properties-content">
        <kendo-grid [data]="properties"
                    #raciParticipantsGrid
                    class="kendo-white-grid approval-grid"
                    [selectable]="selectableSettings"
                    (cellClick)="onRowSelection($event)"
                    *ngIf="!groupBy">

          <kendo-grid-column [headerClass]="'participants-grid'"
                             field="propertyName"
                             title="{{'raci.participantsAssignment.nameTitle' | translate}}"
                             [width]="auto"></kendo-grid-column>
          <kendo-grid-column [headerClass]="'participants-grid'"
                             field="municipally"
                             title="{{'raci.participantsAssignment.titleMunicipally' | translate}}"
                             [width]="auto"></kendo-grid-column>
          <kendo-grid-column [headerClass]="'participants-grid'"
                             field="address"
                             title="{{'raci.participantsAssignment.titleAddress' | translate}}"
                             [width]="auto"></kendo-grid-column>
          <kendo-grid-column [headerClass]="'participants-grid'"
                             field="propertyDataStatus"
                             title="{{'raci.participantsAssignment.titleDataStatus' | translate}}"
                             [width]="auto">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div *ngIf="valoremPublishInformation?.lastSyncStatus" [ngClass]="valoremPublishInformation?.lastSyncStatus === 'ERROR' ? 'published-state-not-published' : ''">
                {{valoremPublishInformation?.lastSyncStatus}}
              </div>
              <div *ngIf="!valoremPublishInformation?.lastSyncStatus">
                NOT SYNCED
              </div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column [headerClass]="'participants-grid'"
                             field="propertyDataStatus"
                             title="{{'raci.participantsAssignment.valoremId' | translate}}"
                             [width]="auto">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div *ngIf="valoremPublishInformation?.lastSyncStatus">
                {{valoremPublishInformation?.id}}
              </div>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
        <div *ngIf="groupBy">
          <div class="spacing-bottom-5" *ngFor="let item of groupData">
            <kendo-grid [data]="item.approvals"
                        class="kendo-white-grid group-header"
                        (cellClick)="onRowSelection($event)"
                        [hideHeader]="true">

              <kendo-grid-column [headerClass]="'participants-grid group-name'"
                                 field="project"
                                 title="project"
                                 class="fill-line"
                                 [width]="auto">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="group-name-wrapper">
                    <h4 class="properties-name">{{item.group}}</h4>
                    <div class="dashed-bottom"></div>
                  </div>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid fill-line'"
                                 field="line"
                                 title="line"
                                 [width]="auto">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="dashed-bottom"></div>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid fill-line'"
                                 field="line"
                                 title="line"
                                 [width]="auto">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="dashed-bottom"></div>
                </ng-template>
              </kendo-grid-column>
            </kendo-grid>
            <kendo-grid [data]="item.tasks"
                        #raciParticipantsGrid
                        class="kendo-white-grid approval-grid group-approval-grid grid-spacing-left-3"
                        [selectable]="selectableSettings"
                        (cellClick)="onRowSelection($event)"
                        kendoGridSelectBy="oid"
                        [(selectedKeys)]="item.selectedRows"
                        (selectedKeysChange)="onSelectionChange(item.group)">
              <kendo-grid-column [headerClass]="'participants-grid'"
                                 field="propertyName"
                                 title="{{'raci.participantsAssignment.nameTitle' | translate}}"
                                 [width]="auto"></kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid'"
                                 field="municipally"
                                 title="{{'raci.participantsAssignment.titleMunicipally' | translate}}"
                                 [width]="auto"></kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid'"
                                 field="address"
                                 title="{{'raci.participantsAssignment.titleAddress' | translate}}"
                                 [width]="auto"></kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid'"
                                 field="propertyDataStatus"
                                 title="{{'raci.participantsAssignment.titleDataStatus' | translate}}"
                                 [width]="auto">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div *ngIf="valoremPublishInformation?.lastSyncStatus" [ngClass]="valoremPublishInformation?.lastSyncStatus === 'ERROR' ? 'published-state-not-published' : ''">
                    {{valoremPublishInformation?.lastSyncStatus}}
                  </div>
                  <div *ngIf="!valoremPublishInformation?.lastSyncStatus">
                    NOT SYNCED
                  </div>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid'"
                                 field="propertyDataStatus"
                                 title="{{'raci.participantsAssignment.valoremId' | translate}}"
                                 [width]="auto">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div *ngIf="valoremPublishInformation?.lastSyncStatus">
                    {{valoremPublishInformation?.id}}
                  </div>
                </ng-template>
              </kendo-grid-column>
            </kendo-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
  <raci-approval-dialog class="raci-approval-matrix-dialog" *ngIf="isApprovalDialogDisplayed" [isGeneralTask]="false" (onApprove)="onApprove($event)"></raci-approval-dialog>
</div>
